
import {UIGameBarbarianInvasion} from '../../../../shared/scripts/ui_game/ui_game_cities_and_knights/UIGameBarbarianInvasion'
import {UIMGamePlayerInformationDefenderOfColonistView} from './UIMGamePlayerInformationDefenderOfColonistView'
import {UIGamePlayerInformationView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationView'
import {UIGamePlayerInformationDefenderOfColonistView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationDefenderOfColonistView'
import {MechanicBarbarianInvasionState, MechanicKnightState} from '@colonist/game-states'
import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'

/**
 * @deprecated UIMGameBarbarianInvasion will be removed once Pixi.js Mobile Player Information view is removed. Please use UIGameBarbarianInvasion.
 */
export class UIMGameBarbarianInvasion extends UIGameBarbarianInvasion {
    private playerInformationDefenderOfColonistViews: UIGamePlayerInformationDefenderOfColonistView[]

    constructor(uiGameManager: UIGameManager, barbarianInvasionState: MechanicBarbarianInvasionState, knightState: MechanicKnightState) {
        super(uiGameManager, barbarianInvasionState, knightState)

        this.playerInformationDefenderOfColonistViews = []
        this.initPlayerInformationDefenderOfColonistViews()
    }

    private createDefenderOfColonistView(playerInformation: UIGamePlayerInformationView): UIGamePlayerInformationDefenderOfColonistView {
        return new UIMGamePlayerInformationDefenderOfColonistView(this.uiGameManager, playerInformation)
    }

    private initPlayerInformationDefenderOfColonistViews() {
        if(this.uiGameManager.playersController == undefined) return
        this.playerInformationDefenderOfColonistViews.forEach((view) => view.destroy())
        this.playerInformationDefenderOfColonistViews = []

        for(const playerInformation of this.uiGameManager.playersController.playerInformationViews) {
            const newPlayerInformationDefenderOfColonistView = this.createDefenderOfColonistView(playerInformation)
            this.playerInformationDefenderOfColonistViews.push(newPlayerInformationDefenderOfColonistView)
        }
    }

    protected onCanvasResize() {
        this.initPlayerInformationDefenderOfColonistViews()
        super.onCanvasResize()
    }
}
